module.exports = __webpack_public_path__ + "images/bug_orange_size_6_b2a96a52e6c9ebbb66b53605b4530468.png";